import { use, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { buttonClass } from './buttonClass';
import { ButtonSizeContext } from './buttonSize';
import s from './ui.module.css';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  readonly size?: 'normal' | 'small' | 'icon';
  readonly block?: boolean;
  readonly loading?: boolean;
  readonly children: ReactNode;
}

export function Button({ variant = 'primary', size: own, block = false, loading = false, disabled, className, children, type = 'button', ...rest }: ButtonProps) {
  const size = own ?? use(ButtonSizeContext);
  const classes = buttonClass({ variant, size, block, className });
  return (
    <button {...rest} type={type} className={classes} disabled={disabled === true || loading} aria-busy={loading || undefined}>
      {loading && <span className={s.spinner} aria-hidden="true" />}
      {loading ? <span className={s.busyLabel}>{children}</span> : children}
    </button>
  );
}
